export enum AwsTargets {
  GET_CREDENTIALS_FOR_IDENTITY = 'AWSCognitoIdentityService.GetCredentialsForIdentity',
  GET_ID = 'AWSCognitoIdentityService.GetId'
}
